

export const Duration = {

    OneMin: 1000 * 60,
    OneHour: 1000 * 60 * 60,
    OneDay: 1000 * 60 * 60 * 24,

};